export default {
  tts: {
    viewHistory: 'View History',
    viewTextList: 'View Text List',
    inputPlaceholder: 'Enter text to convert to audio',
    save: 'Save',
    play: 'Play',
    textList: 'Text List',
    noTextData: 'No text data',
    ttsHistoryList: 'TTS History Play List',
    saveSuccess: 'Saved successfully',
    confirmDelete: 'Are you sure you want to delete this item?',
    repeatPlaySuccess: 'Replay started',
    settingSuccess: 'Settings saved',
    speaking: 'Broadcasting',
    volumeChangeSuccess: 'Volume updated',
    micNotSupported: 'This browser does not support audio input',
    permissionDenied: 'User denied permission.',
    hardwareNotSupported: 'This browser does not support the hardware device.',
    deviceNotFound: 'The specified hardware device was not found.',
    micOpenFailed: 'Unable to open microphone. Error: {info}',
    recordSuffix: 'Recording',
    statusIdle: 'Idle',
    statusPlaying: 'Playing',
    statusRecording: 'Recording',
    statusFree: 'Idle',
    none: 'None',
  },
  speak: {
    recordShout: 'Voice Record Announcement',
    localPreview: 'Local Preview',
    upload: 'Upload',
    shout: 'Broadcast',
    reRecord: 'Re-record',
    startRecord: 'Start Recording',
    textConvertInput: 'Text to Speech Input',
    singlePlaySuccess: 'Single play mode enabled',
    singleLoopSuccess: 'Loop play mode enabled',
    uploadSuccess: 'Uploaded successfully',
    micOpenFailedShort: 'Unable to open microphone.',
  },
  list: {
    audioList: 'Audio List',
    audioImport: 'Import Audio',
    noAudioData: 'No audio data',
    converting: 'Converting audio...',
    importSuccess: 'Imported successfully',
  },
}
